// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './vue/root/App'
import './scss/app.scss'

// vue default plugins
import router from './vue-router'
import store from './vuex'

// vue http-client
import VueResource from 'vue-resource'

// vue-markdown-editor
import VueSimpleMDE from 'vue-simplemde'

// vue-material design plugin
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'

// validator:
import VeeValidate from 'vee-validate'
import { extendValidator } from './validator/validator'

// filters
import { localizeFeeType, localizeSubtype } from './js/filters/filters'
import { langByCookie } from './js/i18n'

import clickOutside from './js/directives/clickOutside'

Vue.config.productionTip = false
// disable vue devtools

Vue.config.devtools = process.env.NODE_ENV === 'dev'
Vue.config.debug = process.env.NODE_ENV === 'dev'
Vue.config.silent = process.env.NODE_ENV === 'dev'

Vue.use(VueResource)

Vue.use(VeeValidate, {
  locale: langByCookie()
})
Vue.use(VueMaterial)
Vue.use(VueSimpleMDE)
VeeValidate.Validator = extendValidator(VeeValidate.Validator)

Vue.directive('click-outside', clickOutside)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

/* Vue filters */
Vue.filter('localizeFeeType', localizeFeeType)
Vue.filter('localizeSubtype', localizeSubtype)

if (process.env.NODE_ENV === 'dev') {
  let attempts = 0
  const maxAttempts = 30 // максимум 1 минута (30 * 2 сек)

  const tryReconnectVueDevtools = () => {
    if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
      window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = Vue
      console.log('%c[Vue DevTools] Reconnected ✅', 'color: #42b983;')
    } else if (attempts < maxAttempts) {
      attempts++
      console.log('%c[Vue DevTools] Waiting to connect...', 'color: #999;')
      setTimeout(tryReconnectVueDevtools, 2000)
    } else {
      console.warn('%c[Vue DevTools] Not found after 1 minute ⏱️', 'color: orange;')
    }
  }

  tryReconnectVueDevtools()
}



// WEBPACK FOOTER //
// ./src/main.js